module.exports = __webpack_public_path__ + "img/img (2).11b0e442.png";